import React, { createContext, useContext, useState } from "react";

const PositionSubAdminConText = createContext();

export const useGetPositionSubAdminConTextConText = () => useContext(PositionSubAdminConText);

function GetPositionSubAdminConTextConText({ children }) {
  const [positionSubAdmin, setPositionSubAdmin] = useState("");
  const clearValue = () => {
    setPositionSubAdmin('');
  };

  return (
    <PositionSubAdminConText.Provider value={{ positionSubAdmin, setPositionSubAdmin, clearValue }}>
      {children}
    </PositionSubAdminConText.Provider>
  );
}

export default GetPositionSubAdminConTextConText;
